export type Key =
  | "accessToken"
  | "refreshToken"
  | "mode"
  | "hideEligibleBox"
  | "homeNotificationPromptDismissed"
  | "isLoginDataStored"

export async function storeValue(key: Key, value: string) {
  localStorage.setItem(key, value)
}

export async function retrieveValue(key: Key) {
  return localStorage.getItem(key)
}

export async function removeValue(key: Key) {
  localStorage.removeItem(key)
}
